module.exports = __webpack_public_path__ + "static/img/torsoScaled3.e8c20c03.jpg";